<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                clearable
                clear-icon="mdi-close-circle"
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
              <v-select
                v-model="approveStatus"
                :items="approveStatusSelect"
                dense
                clearable
                clear-icon="mdi-close-circle"
                outlined
                hide-details
                label="สถานะผู้เข้าร่วม"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <v-select
                v-model="campaignPhase"
                :items="campaignPhaseSelect"
                dense
                clearable
                clear-icon="mdi-close-circle"
                outlined
                hide-details
                label="Campaign Phase"
                class="ma-2"
              ></v-select>
              <v-select
                v-model="choosePackage"
                :items="choosePackageSelect"
                dense
                clearable
                clear-icon="mdi-close-circle"
                outlined
                hide-details
                label="Choose Package"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon color="#871B12" size="30" @click="reloadData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <!-- data table -->
          <v-col cols="12">

      <!-- // แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช
      // แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท
      // แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท -->
            <v-alert class="text-left" dense outlined type="info" >
                Package 1 : แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช
              </v-alert>
            <v-alert class="text-left" dense outlined type="info" >
                Package 2 : แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท
              </v-alert>
            <v-alert class="text-left" dense outlined type="info" >
                Package 3 : แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท
              </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-toolbar flat>
                <v-btn
                  :loading="!dataReady"
                  :disabled="!dataReady"
                  color="blue-grey"
                  class="white--text"
                  @click="exportData()"
                >
                  Download
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="green"
                  dark
                  class="mb-2"
                  @click.stop="updateApproveStatus('approve')"
                >
                  อนุมัติ
                </v-btn>
                |
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  @click.stop="updateApproveStatus('unapprove')"
                >
                  ไม่อนุมัติ
                </v-btn>
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  v-model="searchAll"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>

              <v-card-title>
               พนักงานเข้าร่วมโครงการ  ({{dataItem.length}})
              </v-card-title>

              <v-card-text>
                <v-data-table
                  v-model="selected"
                  :headers="columns"
                  :items="dataItem"
                  :single-select="singleSelect"
                  item-key="empCode"
                  show-select
                  class="elevation-1"
                  :search="searchAll"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                  <!-- <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogApprove = true), getDataFamilyAddress(item)"
                    >
                      <v-icon dark> mdi-account </v-icon>
                    </v-btn>
                  </template> -->
                </v-data-table>
              </v-card-text>

              <v-card-title>
               พนักงานผ่านเงื่อนไขโครงการ  ({{dataItemApprove.length}})
              </v-card-title>
              <v-col>
              <v-btn
                  :loading="!dataReady"
                  :disabled="!dataReady"
                  color="blue-grey"
                  class="white--text"
                  @click="exportDataApprove()"
                >
                  Download
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
              |
                <v-btn
                  color="info"
                  dark
                  @click.stop="updateReceived('received')"
                >
                  รับของ
                </v-btn>
              </v-col>
              <v-card-text>
                <v-data-table
                  v-model="selected"
                  :single-select="singleSelect"
                  item-key="empCode"
                  show-select
                  :headers="columns"
                  :items="dataItemApprove"
                  class="elevation-1"
                  :search="searchAll"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                </v-data-table>
              </v-card-text>

              <v-card-title>
               พนักงานไม่ผ่านเงื่อนไขโครงการ  ({{dataItemUnApprove.length}})
              </v-card-title>
              <v-col>
              <v-btn
                  :loading="!dataReady"
                  :disabled="!dataReady"
                  color="blue-grey"
                  class="white--text"
                  @click="exportDataUnApprove()"
                >
                  Download
                  <v-icon right dark> mdi-cloud-download </v-icon>
                </v-btn>
              </v-col>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItemUnApprove"
                  class="elevation-1"
                  :search="searchAll"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                </v-data-table>
              </v-card-text>

                 <v-card-title>
               พนักงานเข้าไม่ได้ร่วมโครงการ  ({{dataItemEmpNotRegister.length}})
              </v-card-title>
                  <v-card-text>
                <v-data-table
                  v-model="selected"
                  :headers="columns"
                  :items="dataItemEmpNotRegister"
                  item-key="empCode"
                  class="elevation-1"
                  :search="searchAll"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                  <!-- <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogApprove = true), getDataFamilyAddress(item)"
                    >
                      <v-icon dark>  mdi-account </v-icon>
                    </v-btn>
                  </template> -->
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      PK: '',
      path: '/event_punsuk/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'กิจกรรมปันสุข',
          disabled: false,
          href: '/HRM/Event/EventPunsukDataRequest'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      BranchItem: [], // สาขา
      Branch: '', // สาขา
      DepartmentItem: [], // แผนก
      Department: '', // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      approveStatus: '',
      approveStatusSelect: ['waiting', 'approve', 'unapprove'],
      campaignPhase: '',
      campaignPhaseSelect: ['Phase 1', 'Phase 2', 'Phase 3'],
      choosePackage: '',
      choosePackageSelect: ['Package 1', 'Package 2', 'Package 3'],
      searchAll: '',
      dialogEdit: false,
      dialogDelete: false,
      selected: [],
      singleSelect: false,
      session: this.$session.getAll(),
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 50 || 'Name must be less than 50 characters'
      ],
      columns: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          sortable: false,
          value: 'empCode'
        },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'เบอร์โทร', value: 'empTel' },
        { text: 'Phase', value: 'campaignPhase' },
        { text: 'Package', value: 'choosePackage' },
        { text: 'สถานะรับของ', value: 'receivedItem' },
        { text: 'สถานะโครงการ', value: 'eventStatus' }
      ],
      dataItem: [],
      dataItemApprove: [],
      dataItemUnApprove: [],
      dataItemEmpNotRegister: [],
      dataItemFamily: [],
      dataItemAddress: [],
      // End Data Table Config
      headers: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'รหัสผู้อนุมัติ', value: 'empCodeApprove' },
        { text: 'ผู้อนุมัติ', value: 'empFull_NameTH_approve' },
        { text: 'รหัสผู้รับทราบ', value: 'empCodeVerify' },
        { text: 'ผู้รับทราบ', value: 'empFull_NameTH_verify' }
      ]
    }
  },
  async mounted () {
    await this.getGetToken()
    this.dataReady = false
    this.reloadData()
    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async reloadData () {
      await this.getData()
      await this.getDataApprove()
      await this.getDataUnApprove()
      await this.getDataEmpNotRegister()
    },
    async getData () {
      this.dataReady = true
      this.selected = []
      this.dataItem = []
      var Company = this.Company === '' ? '' : '&masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      var ApproveStatus =
        this.approveStatus === '' ? '' : '&eventStatus=' + this.approveStatus
      var CampaignPhase =
        this.campaignPhase === '' ? '' : '&campaignPhase=' + this.campaignPhase
      var ChoosePackage =
        this.choosePackage === '' ? '' : '&choosePackage=' + this.choosePackage

      console.log(this.approveStatus)

      var url =
        this.DNS_IP +
        '/event_punsuk/get?eventStatus=waiting' +
        Company +
        Branch +
        Department +
        ApproveStatus +
        CampaignPhase +
        ChoosePackage
      const response = await axios
        .get(url, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
      if (response.data) {
        this.dataItem = response.data
      }
    },
    async getDataApprove () {
      this.dataReady = true
      this.selected = []
      this.dataItemApprove = []
      var Company = this.Company === '' ? '' : '&masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      var ApproveStatus =
        this.approveStatus === '' ? '' : '&eventStatus=' + this.approveStatus
      var CampaignPhase =
        this.campaignPhase === '' ? '' : '&campaignPhase=' + this.campaignPhase
      var ChoosePackage =
        this.choosePackage === '' ? '' : '&choosePackage=' + this.choosePackage

      console.log(this.approveStatus)

      var url =
        this.DNS_IP +
        '/event_punsuk/get?eventStatus=approve' +
        Company +
        Branch +
        Department +
        ApproveStatus +
        CampaignPhase +
        ChoosePackage
      const response = await axios
        .get(url, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
      if (response.data) {
        this.dataItemApprove = response.data
      }
    },
    async getDataUnApprove () {
      this.dataReady = true
      this.selected = []
      this.dataItemUnApprove = []
      var Company = this.Company === '' ? '' : '&masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      var ApproveStatus =
        this.approveStatus === '' ? '' : '&eventStatus=' + this.approveStatus
      var CampaignPhase =
        this.campaignPhase === '' ? '' : '&campaignPhase=' + this.campaignPhase
      var ChoosePackage =
        this.choosePackage === '' ? '' : '&choosePackage=' + this.choosePackage

      console.log(this.approveStatus)

      var url =
        this.DNS_IP +
        '/event_punsuk/get?eventStatus=unapprove' +
        Company +
        Branch +
        Department +
        ApproveStatus +
        CampaignPhase +
        ChoosePackage
      const response = await axios
        .get(url, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
      if (response.data) {
        this.dataItemUnApprove = response.data
      }
    },
    async getDataEmpNotRegister () {
      this.dataReady = true
      // this.selected = []
      this.dataItemEmpNotRegister = []
      var Company = this.Company === '' ? '' : 'masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department =
        this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      var ApproveStatus =
        this.approveStatus === '' ? '' : '&eventStatus=' + this.approveStatus
      var CampaignPhase =
        this.campaignPhase === '' ? '' : '&campaignPhase=' + this.campaignPhase
      var ChoosePackage =
        this.choosePackage === '' ? '' : '&choosePackage=' + this.choosePackage

      console.log(this.approveStatus)

      var url =
        this.DNS_IP +
        '/event_punsuk/getEmpNotRegister?' +
        Company +
        Branch +
        Department +
        ApproveStatus +
        CampaignPhase +
        ChoosePackage
      const response = await axios
        .get(url, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
      if (response.data) {
        this.dataItemEmpNotRegister = response.data
      }
    },
    async updateApproveStatus (Status) {
      var titleMessage =
        Status === 'approve'
          ? 'ต้องการ ยืนยัน ผู้ผ่านเงือนไขโครงการ ใช่หรือไม่?'
          : 'ยืนยันข้อมูลนี้ ไม่ผ่านผู้ผ่านเงือนไขโครงการใช่หรือไม่'
      this.dataReady = false
      if (this.selected.length > 0) {
        this.$swal({
          title: titleMessage,
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async () => {
            this.dataReady = true
            await this.selected.forEach(async (element) => {
              let data = {
                eventStatus: Status
              }
              await this.updateStatus(element, data)
              // console.log(element.eventStatus)
              // console.log(data.eventStatus)
              if (element.eventStatus === 'waiting') {
                if (data.eventStatus === 'approve') {
                  await this.setUpSendApprove(element)
                  await this.reloadData()
                } else {
                  await this.reloadData()
                }
              }
            })
          })
          .catch(() => {
            this.dataReady = true
          })
      } else {
        alert('กรุณาเลือกพนักงาน')
        this.dataReady = true
      }
    },
    async updateReceived (Status) {
      this.dataReady = false
      if (this.selected.length > 0) {
        this.$swal({
          title: 'ต้องการ ยืนยัน การรับของ ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async () => {
            this.dataReady = true
            this.selected.forEach(async (element) => {
              let data = {
                receivedItem: Status
              }
              this.updateStatus(element, data)
              console.log('element.receivedItem', element.receivedItem)
              console.log('element.eventStatus', element.eventStatus)
              console.log('element.Status', data.Status)
              if (element.receivedItem === 'waiting' && element.eventStatus === 'approve') {
                if (data.receivedItem === 'received') {
                  await this.setUpSendReceived(element)
                  await this.reloadData()
                }
              }
            })
          })
          .catch(() => {
            this.dataReady = true
          })
      } else {
        alert('กรุณาเลือกพนักงาน')
      }
    },
    async updateStatus (element, data) {
      // console.log('updateStatus element', element)
      // console.log('updateStatus data', data)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/event_punsuk/edit/" + element.id,
          data,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(() => {
          console.log('element', element.eventStatus)
        })
    },

    async setUpSendApprove (element) {
      var payload = [
        {
          'type': 'flex',
          'altText': 'ท่านได้ผ่านเงื่อนไขโครงการ',
          'contents': {
            'type': 'bubble',
            'size': 'giga',
            'header': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'text',
                  'text': 'โครงการ วี กรุ๊ป ปันสุข',
                  'align': 'center',
                  'color': '#ffffff',
                  'size': '20px',
                  'style': 'normal'
                }
              ]
            },
            'hero': {
              'type': 'image',
              'url': 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2FmessageImage_1653461431431.jpg?alt=media&token=86f5e002-bdad-4574-a70f-d969f5d9dab6',
              'size': 'full',
              'aspectRatio': '20:13',
              'aspectMode': 'fit',
              'action': {
                'type': 'uri',
                'uri': 'http://linecorp.com/'
              },
              'align': 'center'
            },
            'body': {
              'type': 'box',
              'layout': 'vertical',
              'spacing': 'none',
              'contents': [
                {
                  'type': 'text',
                  'text': 'ท่านผ่านเงื่อนไขโครงการ',
                  'wrap': true,
                  'weight': 'bold',
                  'gravity': 'center',
                  'size': '26px',
                  'color': '#00ab06',
                  'align': 'center'
                },
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'margin': 'lg',
                  'spacing': 'sm',
                  'contents': [
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'sm',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'ชื่อ',
                          'color': '#aaaaaa',
                          'size': 'xs',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': element.empFull_NameTH,
                          'wrap': true,
                          'size': 'sm',
                          'color': '#001580',
                          'flex': 0
                        }
                      ]
                    },
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'sm',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'Phase',
                          'color': '#aaaaaa',
                          'size': 'sm',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': element.campaignPhase,
                          'wrap': true,
                          'color': '#001580',
                          'size': 'sm',
                          'flex': 0
                        }
                      ]
                    },
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'xxl',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'Package',
                          'color': '#aaaaaa',
                          'size': 'sm',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': element.choosePackage,
                          'wrap': true,
                          'color': '#001580',
                          'size': 'sm',
                          'flex': 0
                        }
                      ]
                    },
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'xxl',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'วันที่รับ Package',
                          'color': '#aaaaaa',
                          'size': 'sm',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': '25 กรกฎาคม 2565',
                          'wrap': true,
                          'color': '#001580',
                          'size': 'sm',
                          'flex': 0
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            'footer': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'text',
                  'text': 'นำการ์ดนี้แสดงต่อเจ้าหน้าที่',
                  'size': '14px',
                  'align': 'center',
                  'color': '#ffffff'
                },
                {
                  'type': 'text',
                  'text': 'ฝ่ายบุคคลประจำสาขาของท่าน',
                  'size': '14px',
                  'align': 'center',
                  'color': '#ffffff'
                },
                {
                  'type': 'text',
                  'text': '@V Group Honda',
                  'size': '14px',
                  'align': 'center',
                  'color': '#ffffff'
                }
              ]
            },
            'styles': {
              'header': {
                'backgroundColor': '#b0041b'
              },
              'footer': {
                'backgroundColor': '#b0041b'
              }
            }
          }
        }
      ]
      await this.sendLinePush(payload, element.userLineuserId)
    },
    async setUpSendReceived (element) {
      var payload = [
        {
          'type': 'flex',
          'altText': 'รับของเรียบร้อย',
          'contents': {
            'type': 'bubble',
            'size': 'giga',
            'header': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'text',
                  'text': 'โครงการ วี กรุ๊ป ปันสุข',
                  'align': 'center',
                  'color': '#ffffff',
                  'size': '20px',
                  'style': 'normal'
                }
              ]
            },
            'hero': {
              'type': 'image',
              'url': 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fgive.png?alt=media&token=aa7b0707-4a3a-4f69-971e-4245e3b02777',
              'size': 'full',
              'aspectRatio': '20:13',
              'aspectMode': 'fit',
              'action': {
                'type': 'uri',
                'uri': 'http://linecorp.com/'
              },
              'align': 'center'
            },
            'body': {
              'type': 'box',
              'layout': 'vertical',
              'spacing': 'none',
              'contents': [
                {
                  'type': 'text',
                  'text': 'ท่านได้รับของเรียบร้อย',
                  'wrap': true,
                  'weight': 'bold',
                  'gravity': 'center',
                  'size': '26px',
                  'color': '#00ab06',
                  'align': 'center'
                },
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'margin': 'lg',
                  'spacing': 'sm',
                  'contents': [
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'sm',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'ชื่อ',
                          'color': '#aaaaaa',
                          'size': 'xs',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': element.empFull_NameTH,
                          'wrap': true,
                          'size': 'sm',
                          'color': '#001580',
                          'flex': 0
                        }
                      ]
                    },
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'sm',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'Phase',
                          'color': '#aaaaaa',
                          'size': 'sm',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': element.campaignPhase,
                          'wrap': true,
                          'color': '#001580',
                          'size': 'sm',
                          'flex': 0
                        }
                      ]
                    },
                    {
                      'type': 'box',
                      'layout': 'baseline',
                      'spacing': 'xxl',
                      'contents': [
                        {
                          'type': 'text',
                          'text': 'Package',
                          'color': '#aaaaaa',
                          'size': 'sm',
                          'flex': 1
                        },
                        {
                          'type': 'text',
                          'text': element.choosePackage,
                          'wrap': true,
                          'color': '#001580',
                          'size': 'sm',
                          'flex': 0
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            'footer': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'text',
                  'text': 'อย่าลืมล้างมือ สวมหน้ากากอนามัย',
                  'size': '14px',
                  'align': 'center',
                  'color': '#ffffff'
                },
                {
                  'type': 'text',
                  'text': '@V Group Honda',
                  'size': '14px',
                  'align': 'center',
                  'color': '#ffffff'
                }
              ]
            },
            'styles': {
              'header': {
                'backgroundColor': '#001580'
              },
              'footer': {
                'backgroundColor': '#001580'
              }
            }
          }
        }
      ]
      await this.sendLinePush(payload, element.userLineuserId)
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(this.DNS_IP + '/line/push_message', dt, {
        headers: {
          'Application-Key': localStorage.getItem('ApplicationKey')
        }
      })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(this.DNS_IP + '/master_company/getItem', {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(this.DNS_IP + '/master_branch/getItem', {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(this.DNS_IP + '/master_department/getItem', {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async clear () {
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      this.approveStatus = ''
      this.campaignPhase = ''
      this.choosePackage = ''
      this.selected = []
      await this.reloadData()
    },
    async exportData () {
      var dataItme = []

      // แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช
      // แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท
      // แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท
      // var count = this.dataItem.length
      // if (count > 0) {
      this.dataItem.forEach((element) => {
        console.log('dataItem', element)
        var detail = (element.choosePackage === 'Package 1') ? 'แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช' : (element.choosePackage === 'Package 2') ? 'แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท' : 'แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท'
        let s = {
          'รหัสพนักงาน': element.empCode,
          'รหัสตำแหน่ง': element.positionCode,
          'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
          'ชื่อเล่น': element.empNickname,
          'วันเกิด': element.empBirthday,
          'อายุ': element.AGE,
          'เบอร์ติดต่อ': element.empTel,
          'Facebook': element.empFacebook,
          'LINE ID': element.empLineID,
          'ผู้ติดต่อฉุกเฉิน': element.empEmergencyName,
          'เบอร์ฉุกเฉิน': element.empEmergencyCall,
          'ตำแหน่งงาน': element.positionName,
          'ประเภทตำแหน่งงาน': element.positionTypeName,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'วันที่เริ่มทำงาน': element.startDate,
          'อายุงาน': element.workDate,
          'เฟส': element.campaignPhase,
          'Package': element.choosePackage,
          'รายละเอียด': detail,
          'สถานะรับของ': element.receivedItem,
          'สถานะโครงการ': element.eventStatus,
          'USERLINEID': element.userLineuserId

        }
        dataItme.push(s)
      })
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      var data = XLSX.utils.json_to_sheet(dataItme)
      XLSX.utils.book_append_sheet(wb, data, 'พนักงานที่เข้าร่วมโครงการ') // sheetAName is name of Worksheet

      var dataItemEmpNotRegister = []
      this.dataItemEmpNotRegister.forEach(element => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'รหัสตำแหน่ง': element.positionCode,
          'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
          'ชื่อเล่น': element.empNickname,
          'วันเกิด': element.empBirthday,
          'อายุ': element.AGE,
          'เบอร์ติดต่อ': element.empTel,
          'Facebook': element.empFacebook,
          'LINE ID': element.empLineID,
          'ผู้ติดต่อฉุกเฉิน': element.empEmergencyName,
          'เบอร์ฉุกเฉิน': element.empEmergencyCall,
          'ตำแหน่งงาน': element.positionName,
          'ประเภทตำแหน่งงาน': element.positionTypeName,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'วันที่เริ่มทำงาน': element.startDate,
          'อายุงาน': element.workDate,
          'USERLINEID': element.userLineuserId
        }
        dataItemEmpNotRegister.push(s)
      })

      var EmpNotRegister = XLSX.utils.json_to_sheet(dataItemEmpNotRegister)
      XLSX.utils.book_append_sheet(wb, EmpNotRegister, 'พนักงานที่ไม่ได้เข้าร่วมโครงการ') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'โครงการปันสุข.xls') // name of the file is 'book.xlsx'
      // } else {
      //   alert('ไม่พบข้อมูล')
      // }
    },
    async exportDataApprove () {
      var dataItme = []
      this.dataItemApprove.forEach((element) => {
        console.log('dataItemApprove', element)
        var detail = (element.choosePackage === 'Package 1') ? 'แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช' : (element.choosePackage === 'Package 2') ? 'แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท' : 'แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท'
        let s = {
          'รหัสพนักงาน': element.empCode,
          'รหัสตำแหน่ง': element.positionCode,
          'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
          'ชื่อเล่น': element.empNickname,
          'วันเกิด': element.empBirthday,
          'อายุ': element.AGE,
          'เบอร์ติดต่อ': element.empTel,
          'Facebook': element.empFacebook,
          'LINE ID': element.empLineID,
          'ผู้ติดต่อฉุกเฉิน': element.empEmergencyName,
          'เบอร์ฉุกเฉิน': element.empEmergencyCall,
          'ตำแหน่งงาน': element.positionName,
          'ประเภทตำแหน่งงาน': element.positionTypeName,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'วันที่เริ่มทำงาน': element.startDate,
          'อายุงาน': element.workDate,
          'เฟส': element.campaignPhase,
          'Package': element.choosePackage,
          'รายละเอียด': detail,
          'สถานะรับของ': element.receivedItem,
          'สถานะโครงการ': element.eventStatus,
          'USERLINEID': element.userLineuserId

        }
        dataItme.push(s)
      })
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      var data = XLSX.utils.json_to_sheet(dataItme)
      XLSX.utils.book_append_sheet(wb, data, 'พนักงานผ่านเงื่อนไขโครงการ') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'โครงการปันสุข.xls') // name of the file is 'book.xlsx'
    },
    async exportDataUnApprove () {
      var dataItme = []
      this.dataItemUnApprove.forEach((element) => {
        console.log('dataItemUnApprove', element)
        var detail = (element.choosePackage === 'Package 1') ? 'แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช' : (element.choosePackage === 'Package 2') ? 'แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท' : 'แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท'
        let s = {
          'รหัสพนักงาน': element.empCode,
          'รหัสตำแหน่ง': element.positionCode,
          'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
          'ชื่อเล่น': element.empNickname,
          'วันเกิด': element.empBirthday,
          'อายุ': element.AGE,
          'เบอร์ติดต่อ': element.empTel,
          'Facebook': element.empFacebook,
          'LINE ID': element.empLineID,
          'ผู้ติดต่อฉุกเฉิน': element.empEmergencyName,
          'เบอร์ฉุกเฉิน': element.empEmergencyCall,
          'ตำแหน่งงาน': element.positionName,
          'ประเภทตำแหน่งงาน': element.positionTypeName,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'วันที่เริ่มทำงาน': element.startDate,
          'อายุงาน': element.workDate,
          'เฟส': element.campaignPhase,
          'Package': element.choosePackage,
          'รายละเอียด': detail,
          'สถานะรับของ': element.receivedItem,
          'สถานะโครงการ': element.eventStatus,
          'USERLINEID': element.userLineuserId

        }
        dataItme.push(s)
      })
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      var data = XLSX.utils.json_to_sheet(dataItme)
      XLSX.utils.book_append_sheet(wb, data, 'พนักงานไม่ผ่านเงื่อนไขโครงการ') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'โครงการปันสุข.xls') // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Event/EventPunsukDataRequest.vue